import { getIsSmallDevice } from './isSmallDevice';

let scrollPosition: number | null = null;

// NOTE: Needed to prevent body scroll on iOS Safari when virtual keyboard is open
// https://bugs.webkit.org/show_bug.cgi?id=141832
export function blockBackgroundScroll(): void {
  const htmlElement = document.querySelector('html');

  if (!htmlElement) {
    return;
  }

  scrollPosition = htmlElement.scrollTop;

  // NOTE: Needed to simulate scroll position on fixed body when opening modal
  if (getIsSmallDevice()) {
    htmlElement.style.position = 'fixed';
    htmlElement.style.width = '100%';
    htmlElement.style.marginTop = `-${scrollPosition}px`;
  }
}

export function enableBackgroundScroll(): void {
  const htmlElement = document.querySelector('html');

  if (!htmlElement) {
    return;
  }

  // NOTE: Needed to return to original body scroll position when closing modal
  if (getIsSmallDevice()) {
    htmlElement.style.position = 'unset';
    htmlElement.style.marginTop = 'unset';
    htmlElement.style.width = 'initial';

    htmlElement.scrollTo({
      top: scrollPosition ?? 0,
    });
  }
}
